import React,{useState,useEffect,useRef }  from 'react';
import { getAllUsersDetails,createUser } from '../../redux/actions/authActions';
import { validateEmail } from '../../utils/helperFuntions';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Typography, Grid,CircularProgress} from '@mui/material';
import './Styles.scss';
import { DataGrid } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';  

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import axios from 'axios';
import { toast } from 'react-toastify';
import { styled } from '@mui/material/styles';
import DeleteIcon from '@mui/icons-material/Delete';
import EditNoteIcon from '@mui/icons-material/EditNote';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Switch, FormControlLabel} from "@mui/material";
import { Label } from '@mui/icons-material';
import PageLoaderComp from '../pageLoaderComp';


const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  ...theme.applyStyles('dark', {
    backgroundColor: '#1A2027',
  }),
}));


  
function UsersComp() {
    const [pageLoading, setPageLoading] = useState(false);
  const [isActive, setIsActive] = useState(true); // State for the switch
    const dispatch= useDispatch();
    const { loading,all_users,auth_token,user } = useSelector((state) => state.auth);
    const [anchorEl, setAnchorEl] = useState(null);
    const openEl = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleCloseEl = () => {
        setAnchorEl(null);
    };
  const [formData, setFormData] = useState({
    "firstName": "",
    "lastName": "",
    "email": "",
    "status": isActive,
    "role": "ROLE_ADMIN"
  });

const [open, setOpen] = useState(false);
const [buttonLoading, setButtonLoading] = useState(false);
const [isSubmitted, setIsSubmitted] = useState(false);
const isFetched = useRef(false);
 // Handle switch toggle
 const handleToggle = (event) => {
    setIsActive(event.target.checked);
    setFormData({
        ...formData,
        ['status']: event.target.checked,
      });
  };
  console.log("formData",formData)
const options = [
    <span>Edit</span>,
    <span>Delete</span>,
];
const ITEM_HEIGHT = 48;
const columns = [
    // { field: 'id', headerName: 'ID'},
    { field: 'firstName', headerName: 'First name', width: 280 },
    { field: 'lastName', headerName: 'Last name', width: 280 },
    { field: 'role', headerName: 'Role', width: 200,},
    { field: 'email', headerName: 'Email', width: 400,},
    { field: 'status', headerName: 'Status', width: 100, renderCell: (params) => {
        // Conditionally display status text
        return (
            <span style={{ color: params.value ? 'green' : 'red' }}>
                {params.value ? 'Active' : 'Inactive'}
            </span>
        );
    },},
    { headerName: 'Action', width: 100, renderCell: (params) => {
        // Conditionally display status text
        
        return (
            <>
                {
                user&& user.role==='ROLE_ADMIN'?
                <div>
                <IconButton
                    aria-label="more"
                    id="long-button"
                    aria-controls={openEl ? 'long-menu' : undefined}
                    aria-expanded={openEl ? 'true' : undefined}
                    aria-haspopup="true"
                    onClick={handleClick}
                >
                    <MoreVertIcon />
                </IconButton>
                <Menu
                    id="long-menu"
                    MenuListProps={{
                    'aria-labelledby': 'long-button',
                    }}
                    anchorEl={anchorEl}
                    open={openEl}
                    onClose={handleCloseEl}
                    slotProps={{
                    paper: {
                        style: {
                        maxHeight: ITEM_HEIGHT * 4.5,
                        width: '20ch',
                        },
                    },
                    }}
                >
                    {options.map((option) => (
                    <MenuItem key={option} selected={option === 'Pyxis'} onClick={handleCloseEl}>
                        {option}
                    </MenuItem>
                    ))}
                </Menu>
                </div>
                :""}
                {/* <span style={{ color: 'green',cursor:"pointer" }}>
                    <EditNoteIcon color='green' />
                </span>
                <span style={{ color: 'red',cursor:"pointer" }}>
                    <DeleteIcon color='red' />
                </span> */}
            </>
        );
    },},
   /*  {
      field: 'fullName',
      headerName: 'Full name',
      description: 'This column has a value getter and is not sortable.',
      sortable: false,
      width: 'auto',
      valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
    }, */
  ];
  
  const paginationModel = { page: 0, pageSize: 5 };
  

useEffect(() => {
    if (auth_token && !isFetched.current) {
        const getAllUsersFunc = async () => {
            setPageLoading(true);
            let data = await dispatch(getAllUsersDetails());
            isFetched.current = true;
            setPageLoading(false);
           /*  if(data.success){

            } */
        };

        getAllUsersFunc();
    }
    }, [auth_token, dispatch]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleChange = (event) => {
    setFormData({
        ...formData,
        [event.target.name]: event.target.value,
      });
  };
  const handleSubmit =async () => {
    setIsSubmitted(true);
    if(formData.firstName && formData.lastName && formData.email && validateEmail(formData.email)){
        setButtonLoading(true)
        const data = await dispatch(createUser(formData));  
        
        setButtonLoading(false)
        if(data.success){
            dispatch(getAllUsersDetails());
            handleClose(false);
        }
       
    }
  };
  return (
    <>
    {pageLoading ?
        <PageLoaderComp />
    :
    <Box className="rightContainer">
    <Grid container spacing={2}
    
    sx={{
      justifyContent: "center",
      alignItems: "center",
    }}
    >
        <Grid item xs={6}>
            <Typography component="h1" variant="h5" mb={0} mt={0}>
            User list
            </Typography>
        </Grid>
        <Grid item xs={6}>
            <Item className='text-right'><Button
                variant={'contained'}
                sx={{ marginBottom:"5px" }}
                onClick={handleClickOpen} > Add User</Button></Item>
        </Grid>
    </Grid>


        <Paper sx={{ height: 500, width: '100%' }}>
            <DataGrid
                rows={all_users}
                columns={columns}
                initialState={{ pagination: { paginationModel } }}
                pageSizeOptions={[5, 10]}
                checkboxSelection={false}
                sx={{ 
                  '& .MuiDataGrid-columnHeader': {
                    backgroundColor: 'rgba(0, 0, 0, 0)', 
                    color: 'black', 
                    fontSize: '16px', 
                  },
                  '& .MuiDataGrid-columnHeaders': {
                    backgroundColor: 'rgba(139, 175, 145, 0.3)', 
                    color: 'black', 
                    fontSize: '16px', 
                  },
                  '& .MuiDataGrid-row--borderBottom': {
                    backgroundColor: 'rgba(0, 0, 0, 0) !important', 
                    color: 'black', 
                    fontSize: '16px', 
                  },
                  border: 0 
                }}
            />
        </Paper>
      
    </Box>
    }
    <Dialog
        open={open}
        onClose={handleClose}
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "20px",
          },
        }}
        /* PaperProps={{
          component: 'form',
          onSubmit: (event) => {
            event.preventDefault();
            const formData = new FormData(event.currentTarget);
            const formJson = Object.fromEntries(formData.entries());
            const email = formJson.email;
            console.log(email);
            handleClose();
          },
        }} */
      >
        <Box sx={{padding:'10px'}} >
        <DialogTitle>Add User</DialogTitle>
        <DialogContent>
         {/*  <DialogContentText>
            To subscribe to this website, please enter your email address here. We
            will send updates occasionally.
          </DialogContentText> */}
          <FormControl fullWidth variant="standard" sx={{ mt: 1,mb: 1, minWidth: 120 }}>
                <InputLabel id="demo-simple-select-label">User Role</InputLabel>
                <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={formData.role}
                name={'role'}
                error={isSubmitted && !formData.role?true:false}
                label="User Role"
                onChange={handleChange}
                >
                    <MenuItem value={"ROLE_ADMIN"}>Admin</MenuItem>
                    <MenuItem value={"ROLE_STAFF"}>Staff</MenuItem>
                    <MenuItem value={"ROLE_CLIENT"}>Client</MenuItem>
                </Select>
            </FormControl>
          <TextField
            autoFocus
            required
            margin="dense"
            id="firstName"
            name="firstName"
            value={formData.firstName}
            label="First Name"
            type="text"
            fullWidth
            variant="standard"
            error={isSubmitted && !formData.firstName?true:false}
            onChange={handleChange}
          />
          <TextField
            autoFocus
            required
            margin="dense"
            id="lastName"
            name="lastName"
            value={formData.lastName}
            label="Last Name"
            type="text"
            fullWidth
            variant="standard"
            error={isSubmitted && !formData.lastName?true:false}
            onChange={handleChange}
          />
          <TextField
            autoFocus
            required
            margin="dense"
            id="name"
            name="email"
            value={formData.email}
            label="Email Address"
            type="email"
            fullWidth
            variant="standard"
            error={isSubmitted && !formData.email?true:false}
            onChange={handleChange}
          />
          <Box className="status-item">

          <div>Status</div>


          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
      {/* Switch with label */}
      <FormControlLabel
        control={
          <Switch
            checked={isActive}
            onChange={handleToggle}
            color="primary" // Customize color (primary/secondary/custom)
          />
        }
        label={
          <Typography
            style={{
              color: isActive ? "green" : "red", // Change label color based on state
              fontWeight: "bold",
            }}
          >
            {isActive ? "Active" : "Inactive"} {/* Label text */}
          </Typography>
        }
      />
    </div>

      
          </Box>
        </DialogContent>
        <DialogActions>
        <Button variant={'contained'} type="button" onClick={handleSubmit}   >{buttonLoading ?  <CircularProgress size={24} sx={{ color: '#fff' }} /> : 'Add'}</Button>
          <Button variant={'outlined'} onClick={handleClose}>Cancel</Button>
         
        </DialogActions>
        </Box>
      </Dialog>
    
    </>
    
  );
}

export default UsersComp;
